module.exports = __webpack_public_path__ + "img/product-sm-3.e89cffdd.png";